import { render, staticRenderFns } from "./Counseling.vue?vue&type=template&id=2bcab321&scoped=true&"
import script from "./Counseling.vue?vue&type=script&lang=ts&"
export * from "./Counseling.vue?vue&type=script&lang=ts&"
import style0 from "./Counseling.vue?vue&type=style&index=0&id=2bcab321&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bcab321",
  null
  
)

export default component.exports